function withAuthorizationHeader(init, accessToken) {
    const headers = new Headers(init?.headers);
    headers.set('Authorization', `DPoP ${accessToken}`);
    return { ...init, headers };
}
/**
 * 요청 전 토큰 선갱신, DPoP Authorization 헤더 부착, 401 시 한 번 재시도를 처리한다.
 */
export function authRefreshLayer(deps) {
    let sessionExpiredCalled = false;
    return (next) => async (path, init) => {
        if (deps.accessTokenStore.getAccessToken() === null) {
            await deps.refreshSession();
        }
        const accessToken = deps.accessTokenStore.getAccessToken();
        const requestInit = accessToken ? withAuthorizationHeader(init, accessToken) : init;
        let res = await next(path, requestInit);
        // DPoP-Nonce가 없는 401만 세션 갱신으로 본다. nonce 401은 dpopHeaderLayer가 재시도한다.
        if (res.status === 401 && !res.headers.get('DPoP-Nonce')) {
            const refreshed = await deps.refreshSession();
            if (refreshed) {
                const newToken = deps.accessTokenStore.getAccessToken();
                const retryInit = newToken ? withAuthorizationHeader(init, newToken) : init;
                res = await next(path, retryInit);
            }
            else if (!sessionExpiredCalled) {
                // 갱신 실패 시 onSessionExpired는 한 번만 호출한다.
                sessionExpiredCalled = true;
                deps.onSessionExpired();
            }
        }
        return res;
    };
}
//# sourceMappingURL=authRefreshLayer.js.map